import { createAsyncThunk } from '@reduxjs/toolkit'
import { ChainInfo, EthProperty, getChains } from '../../../api/v1/chains'
import { L1ChainId, L2ChainId } from '../../../types'
import {
  BLOCKED_CHAINS,
  ChainType,
  MainnetChainIds,
  NETWORKS_SELECTION_PRIORITY,
  TestnetChainIds,
} from '../../../constants/chains'
import { ENABLE_STARKNET } from '../../../config'
import { sortNetworksByLayerTwoChainId } from '../../../utils/networks'
import { NetworkRegistry } from '../../../utils/networkRegistry'
import NETWORKS from 'constants/networks.json'

function addNetworksProfile(chains: ChainInfo[]): ChainInfo[] {
  // const networks = await getStaticNetworksProfile().catch((e) => {
  //   throw new Error('getStaticNetworksProfile fail: ' + e?.message)
  // })
  // if (!networks || !networks?.length) {
  //   throw new Error('getStaticNetworksProfile fail: networks undefined')
  // }

  // @ts-ignore
  return chains.reduce<ChainInfo[]>((prev, curr) => {
    const nets = NETWORKS.filter((n) => n.chainId === curr.layerOneChainId)
    const list = [] as ChainInfo[]
    if (nets.length > 0) {
      nets.forEach((net) => {
        const additional = {
          ...curr,
          name: net.name,
          symbol: net.symbol,
          explorerUrl: net.explorerUrl,
          iconUrl: net.iconUrl,
          rpcUrl: net.rpcUrl,
          decimals: net.decimals,
        }

        list.push(additional)
      })
      return prev.concat(list)
    } else {
      return prev
    }
  }, [])
}

const zkChains = [
  {
    chainId: 1,
    chainType: 0,
    layerOneChainId: '0x89',
    mainContract: '0x94f2ebe929fe948f960908ec57e5d7792facac07',
    layerZeroContract: '0xe89635a7339bf46198f76b17bcfdad977699cc13',
    gasTokenId: 33,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 2,
    chainType: 0,
    layerOneChainId: '0xa86a',
    mainContract: '0xa005091c98e6793b90e1340bbd36c5d6de36fb60',
    layerZeroContract: '0x9dc75660523581d56d4c8efd5819161e15bbc88c',
    gasTokenId: 34,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 3,
    chainType: 0,
    layerOneChainId: '0x38',
    mainContract: '0x1ee09a2caa0813a5183f90f5a6d0e4871f4c6002',
    layerZeroContract: '0x028781ceed4a2264466ef5ab73c91603087fa131',
    gasTokenId: 35,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 5,
    chainType: 0,
    layerOneChainId: '0x144',
    mainContract: '0x46d6e42fb6e04695156b5ad38a3ec6fa9c59147d',
    layerZeroContract: '0x66d4ff37b0c908cd3cf02e9ba8796073d914029e',
    gasTokenId: 36,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 7,
    chainType: 0,
    layerOneChainId: '0xe708',
    mainContract: '0x3e98568770af932353a2a8c3e3b77cdb7f0c2fa1',
    layerZeroContract: '0xff73a1a1d27951a005eb23276dc99cb7f8d5420a',
    gasTokenId: 36,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 9,
    chainType: 0,
    layerOneChainId: '0xa4b1',
    mainContract: '0xed5d1e1320720cae8bb40275550a7d307a082ac3',
    layerZeroContract: '0x9dc75660523581d56d4c8efd5819161e15bbc88c',
    gasTokenId: 36,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 10,
    chainType: 0,
    layerOneChainId: '0xa',
    mainContract: '0xee7981c4642de8d19aed11da3bac59277dfd59d7',
    layerZeroContract: '0x62351b47e060c61868ab7e05920cb42bd9a5f2b2',
    gasTokenId: 36,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 11,
    chainType: 0,
    layerOneChainId: '0x2105',
    mainContract: '0x161f4baab4052f20f5f4347ec4422556aa0477f0',
    layerZeroContract: '0x3545fb62209935ab6038f3a1b40403ddffe6e49c',
    gasTokenId: 36,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
  {
    chainId: 15,
    chainType: 0,
    layerOneChainId: '0xcc',
    mainContract: '0x3c3f4b866f8c6f0d2c912fee36d5ad337a9aa98e',
    layerZeroContract:
      '0x0000000000000000000000000000000000000000000000000000000000000000',
    gasTokenId: 35,
    validator: '0x9464b23de0f5a8cc3f5c82ccd2aabcfbedaa1467',
  },
]

// const zkEthProperty = {
//   chainId: L2ChainId
//   layerOneChainId: L1ChainId
//   depositConfirmation: number
//   gasTokenId: TokenId
//   gateways: GatewayInfo[]
// }

export const getChainsActions = createAsyncThunk<{
  chains: ChainInfo[]
  changePubKeyChainId: L2ChainId
  ethProperty: EthProperty
}>('market/getChainsActions', async () => {
  // const { data } = await getChains()

  const changePubkeyChainId = 7

  let chains: ChainInfo[] = zkChains as any

  chains = chains.map((v) => ({
    ...v,
    decimals: 0,
  }))

  for (let i in chains) {
    // chains[i].gateway = false
    // Copy a field named 'layerTwoChainId' for clarity on chain ID information during development.
    chains[i].layerTwoChainId = chains[i].chainId
  }

  // Add the gateway chains to supported chain list
  // chains.push({
  //   // Add some zklink keys
  //   layerOneChainId: ethProperty.layerOneChainId,
  //   layerTwoChainId: ethProperty.chainId,
  //   chainId: ethProperty.chainId,
  //   mainContract: '',
  //   layerZeroContract: '',
  //   depositConfirmation: ethProperty.depositConfirmation,
  //   gasTokenId: ethProperty.gasTokenId,
  //   chainType: ChainType.Evm,

  //   // Add some zkex keys
  //   isSupport: true,
  //   id: 0,
  //   updateTime: 0,

  //   // Chains marked for communication only through a gateway
  //   gateway: true,
  //   decimals: 0,
  // })

  // if (!ENABLE_STARKNET) {
  //   const starknetChainIds: L1ChainId[] = [
  //     TestnetChainIds.StarknetGoerli,
  //     MainnetChainIds.Starknet,
  //   ]
  //   chains = chains.map((v) => {
  //     if (starknetChainIds.includes(v.layerOneChainId)) {
  //       // v.isSupport = false
  //     }
  //     return v
  //   })
  // }
  // chains = chains.filter((v) => !BLOCKED_CHAINS.includes(v.layerOneChainId))
  const fulledChains = addNetworksProfile(chains as any)

  // Update the network list
  // This is a static class, so it will be updated globally
  // This class is used to get the network information without react hooks
  NetworkRegistry.update(fulledChains)

  return {
    chains: sortNetworksByLayerTwoChainId(
      fulledChains,
      NETWORKS_SELECTION_PRIORITY,
    ),
    changePubKeyChainId: changePubkeyChainId,
    // Convert the chain id from hex string to integer
    // ethProperty,
  } as any
})
